import { render } from "./AshBalance.vue?vue&type=template&id=b838b38e&scoped=true"
import script from "./AshBalance.vue?vue&type=script&lang=js"
export * from "./AshBalance.vue?vue&type=script&lang=js"

import "./AshBalance.vue?vue&type=style&index=0&id=b838b38e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b838b38e"]])

export default __exports__